module.exports = __webpack_public_path__ + "static/03-max@2x-42217b1c4a1805d9fc9cd83086092683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/03-max@2x.jpg
// module id = 2514
// module chunks = 168707334958949